
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-monitoring",
      function () {
        return require("private-next-pages/trademark-monitoring.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-monitoring"])
      });
    }
  